import {defineStore} from 'pinia'

export const useLoadingStore = defineStore({
  id: 'loadingStore',
  state: () => ({
    isLoadingActive: false,
    isFirstTimeLoadingActive: false,
    loadingCount: 0,
    timerRunning: false
  }),
  actions: {
    startLoading() {
      this.loadingCount++;
      this._activateTimer();
    }, _activateTimer() {
      if (this.timerRunning)
        return;
      this.timerRunning = true;
      setTimeout(() => {
        this.isLoadingActive = this.loadingCount > 0;
        this.timerRunning = false;
      }, 250)
    }, stopLoading() {
      this.loadingCount--;
      if(this.loadingCount < 0 )
        this.loadingCount = 0;
      if (this.isLoadingActive)
        this.isLoadingActive = this.loadingCount > 0;
      else
        this._activateTimer();
    }, startFirstTimeLoading() {
      this.isFirstTimeLoadingActive = true;
    }, stopFirstTimeLoading() {
      this.isFirstTimeLoadingActive = false;
    }, async awaitLoadingFinish(initialDelay: number) {
      return new Promise<void>((resolve, reject) => {
        const checkCondition = () => {
          if (!this.timerRunning && !this.loadingCount) {
            resolve();
            return;
          }
          setTimeout(checkCondition, 200);
        };
        setTimeout(checkCondition, initialDelay);
      });
    }
  }
})

